import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';

const navigationSubMenus = document.querySelectorAll(
	'.block-navigation-submenu'
);
const navigationBackButtons = document.querySelectorAll(
	'.block-navigation-submenu__back-button'
);

const clickNavigationBackButton = (e) => {
	const currentNavigationBackButton = e.currentTarget;
	const navigationLink = currentNavigationBackButton.closest(
		'.block-navigation-link'
	);

	if (!navigationLink) {
		return;
	}

	navigationLink.classList.remove('active');
};

const setMenuOffset = () => {
	if (0 === navigationSubMenus.length) {
		return;
	}

	const remBase = getRemBase();

	// Pass 1: reset all offsets (writes only).
	navigationSubMenus.forEach((navigationSubMenu) => {
		navigationSubMenu.style.setProperty('--submenuOffset', '0rem');
	});

	// Pass 2: read all measurements and compute offsets (reads only — one
	// layout pass after the batch reset above).
	const offsets = Array.from(navigationSubMenus).map((navigationSubMenu) => {
		const rect = navigationSubMenu.getBoundingClientRect();

		if (0 === rect.width || !rect.x) {
			return 0;
		}

		const menuLeft = rect.x;
		const menuRight = rect.x + rect.width;
		const navigationBlock = navigationSubMenu.closest(
			'.block-navigation__container'
		);
		let blockWidth = window.innerWidth;

		if (navigationBlock) {
			const styles = window.getComputedStyle(navigationBlock);
			blockWidth =
				navigationBlock.offsetWidth -
				parseFloat(styles['padding-left']) -
				parseFloat(styles['padding-right']);
		}

		const containerLeft = (window.innerWidth - blockWidth) / 2;
		const containerRight = containerLeft + blockWidth;

		if (menuLeft < containerLeft) {
			return containerLeft - menuLeft;
		} else if (menuRight > containerRight) {
			return containerRight - menuRight;
		}

		return 0;
	});

	// Pass 3: write all final offsets (writes only).
	navigationSubMenus.forEach((navigationSubMenu, i) => {
		navigationSubMenu.style.setProperty(
			'--submenuOffset',
			`${offsets[i] / remBase}rem`
		);
	});
};

if (navigationBackButtons.length > 0) {
	navigationBackButtons.forEach((navigationBackButton) => {
		navigationBackButton.addEventListener(
			'click',
			clickNavigationBackButton
		);
	});
}

setMenuOffset();

window.addEventListener('navigation-submenu-opened', setMenuOffset);
window.addEventListener('resize', throttle(setMenuOffset, 100));
window.addEventListener('load', setMenuOffset);
